import { render, staticRenderFns } from "./CustomerProductTray.vue?vue&type=template&id=99f96060&scoped=true"
import script from "./CustomerProductTray.vue?vue&type=script&lang=js"
export * from "./CustomerProductTray.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/customer-product-select.css?vue&type=style&index=0&id=99f96060&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99f96060",
  null
  
)

export default component.exports